exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._26Y8dhO3pXAOix_NqJxzzv{-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}html[dir=ltr] ._26Y8dhO3pXAOix_NqJxzzv,html[dir=rtl] ._26Y8dhO3pXAOix_NqJxzzv{padding-right:12px;padding-left:12px}.jYeriKKKqepNEQIc6KEbh,.ZY3ay4Gk8xESNdfZiLPAm,._1Kiszd2aANLjMc8DUL1mgF{width:100%}", ""]);
// Exports
exports.locals = {
	"emptyStateContainer": "_26Y8dhO3pXAOix_NqJxzzv",
	"container": "jYeriKKKqepNEQIc6KEbh",
	"detailsMessage": "ZY3ay4Gk8xESNdfZiLPAm",
	"mainMessage": "_1Kiszd2aANLjMc8DUL1mgF"
};